import PropTypes from 'prop-types';
import React from 'react';
import Dialog from './Dialog';
import * as style from '../style';
import { translate } from '../../../common/i18n';

const Save = React.memo(({ onChange }) => {
    const changeStrategy = onChange;

    return (
        <div className="main-strategy-list">
            <ul className="main-list" style={{ overflowY: 'scroll', height: 'calc(100vh - 69px)' }}>
                <li>
                    <button onClick={() => changeStrategy('90_porcento')}>90 Porcento</button>
                    <button onClick={() => changeStrategy('barrier_bb8')}>Barrier BB 8</button>
                    <button onClick={() => changeStrategy('bethoven')}>Bethoven</button>
                    <button onClick={() => changeStrategy('blaze')}>Blaze</button>
                    <button onClick={() => changeStrategy('bola_azul_y_roja')}>Bola Azul Y Roja</button>
                    <button onClick={() => changeStrategy('botpremium_probot')}>Bot Premium Pro Bot</button>
                    <button onClick={() => changeStrategy('bull')}>Bull</button>
                    <button onClick={() => changeStrategy('dubai_2')}>Dubai 2.0</button>
                    <button onClick={() => changeStrategy('dynamic_over_zero')}>Dynamic Over Zero</button>
                    <button onClick={() => changeStrategy('elon_musk_differs')}>Elon Musk Differs</button>
                    <button onClick={() => changeStrategy('estrategia_somente_par')}>Estratégia Somente Par</button>
                    <button onClick={() => changeStrategy('even_fenix')}>Even Fenix</button>
                    <button onClick={() => changeStrategy('extreme_bot')}>Extreme Bot</button>
                    <button onClick={() => changeStrategy('grenade')}>Grenade</button>
                    <button onClick={() => changeStrategy('harpia_banca_pequena')}>Harpia Banca Pequena</button>
                    <button onClick={() => changeStrategy('kevin_cash')}>Kevin Cash</button>
                    <button onClick={() => changeStrategy('lionel')}>Lionel</button>
                    <button onClick={() => changeStrategy('mano_de_dios')}>Mano de Dios</button>
                    <button onClick={() => changeStrategy('master_even_odd')}>Master Even Odd</button>
                    <button onClick={() => changeStrategy('megalodon')}>Megalodon</button>
                    <button onClick={() => changeStrategy('metawave')}>Metawave</button>
                    <button onClick={() => changeStrategy('next_2')}>Next 2.0</button>
                    <button onClick={() => changeStrategy('odyssey_xl')}>Odyssey XL</button>
                    <button onClick={() => changeStrategy('over_1')}>Over 1</button>
                    <button onClick={() => changeStrategy('over_turtle')}>Over Turtle</button>
                    <button onClick={() => changeStrategy('over_under_stan_lee')}>Stan Lee</button>
                    <button onClick={() => changeStrategy('reset_call_put_2023')}>Reset Call Put 2023</button>
                    <button onClick={() => changeStrategy('rf_compressor_signal_bot')}>RF Compressor Signal</button>
                    <button onClick={() => changeStrategy('rise_fall_alternado')}>Rise Fall Alternado</button>
                    <button onClick={() => changeStrategy('rise_fall_analises_ticks')}>Rise Fall Analises Ticks</button>
                    <button onClick={() => changeStrategy('rise_fall_gale_parcelado')}>Rise Fall Gale Parcela</button>
                    <button onClick={() => changeStrategy('rita_3')}>Rita 3</button>
                    <button onClick={() => changeStrategy('rush')}>Rush</button>
                    <button onClick={() => changeStrategy('skylander_differs_com_soros')}>
                        Skylander Differs Com Soros
                    </button>
                    <button onClick={() => changeStrategy('sniper_americana')}>Sniper Americano</button>
                    <button onClick={() => changeStrategy('solo_par_impar')}>Solo Par Impar</button>
                    <button onClick={() => changeStrategy('soros_touch_no_touch')}>Soros Touch No Touch</button>
                    <button onClick={() => changeStrategy('super_ganador_10')}>Super Ganador 10</button>
                    <button onClick={() => changeStrategy('super_rise_fall_premium')}>Super Rise Fall Premium</button>
                    <button onClick={() => changeStrategy('superfast_rf')}>Superfast RF</button>
                    <button onClick={() => changeStrategy('superior_4')}>Superior 4</button>
                    <button onClick={() => changeStrategy('the_match_box_over')}>The Match Box Over</button>
                    <button onClick={() => changeStrategy('tick_azul_94')}>Tick Azul 94</button>
                    <button onClick={() => changeStrategy('tick_pip_rf')}>Tick Pip RF</button>
                    <button onClick={() => changeStrategy('turbo_4')}>Turbo 4.0</button>
                    <button onClick={() => changeStrategy('under_7_vitoria_rapida')}>Under 7 Vitoria Rapida</button>
                    <button onClick={() => changeStrategy('under_profit_bajo')}>Under Profit Bajo</button>
                </li>
            </ul>
        </div>
    );
});

Save.propTypes = {
    onChange: PropTypes.func.isRequired,
};

export default class StoreDialog extends Dialog {
    constructor() {
        const closeDialog = () => {
            this.close();
        };

        const onChange = arg => {
            this.limitsPromise(arg);
            closeDialog();
        };
        super('store-dialog', translate('Bot Store'), <Save closeDialog={closeDialog} onChange={onChange} />, {
            height   : 'auto',
            width    : '78em',
            resizable: false,
        });
        this.registerCloseOnOtherDialog();
    }

    change() {
        this.open();
        return new Promise(resolve => {
            this.limitsPromise = resolve;
        });
    }
}



// WEBPACK FOOTER //
// ./src/botPage/view/Dialogs/Store.js